module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/error.65d70633.svg";